import Image from 'next/image';
import { useState } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

// Components
import Icon from '@/components/base/Icon';

// Lib
import { POST_TYPE } from '@/lib/scheduler/postType';

type PostThumbnailProps = ComponentPropsWithoutRef<'div'> & {
    thumbnail: string;
    postType: keyof typeof POST_TYPE;
};

const PostThumbnail = ({ thumbnail, postType }: PostThumbnailProps) => {
    const [errorImg, setErrorImage] = useState(false);
    return (
        <div className="relative flex h-13 w-13 rounded-m border-2 border-white dark:border-icoDarkMode-deepBlack">
            <div className="square flex h-full w-full flex-1 items-center justify-center rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack">
                <Icon
                    icon={POST_TYPE[postType]?.icon ?? 'content'}
                    className="flex items-center justify-center text-xl text-icoGray-500 dark:text-icoDarkMode-wolf"
                />
            </div>
            {!errorImg && thumbnail ? (
                <Image
                    fill
                    alt=""
                    src={thumbnail}
                    className="h-full w-full rounded-[1px] object-cover"
                    onError={() => setErrorImage(true)}
                />
            ) : null}
        </div>
    );
};

export default PostThumbnail;
